/*
  Chora: one moment per inner page ([data-chora-reveal])

  A section that carries the attribute plays its moment once, when it comes into view: the
  ray and the glint across ጮራ on Om oss, the branches and the rising label on the product
  page (the CSS is in assets/chora.css, "One moment per page"). Everything is visible by
  default. Only a section whose top is still in the lower half of the screen, or below it, when
  this runs is set to its start ("is-waiting") and then played ("is-lit") once a quarter of it
  shows, so nothing is ever left hidden waiting for a script, and a section already filling the
  screen simply stays as it is. Under reduced motion nothing
  is touched. No dependencies, ES2018.
*/
(function () {
  'use strict';
  if (window.__choraMoments) return;
  window.__choraMoments = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      io.unobserve(el);
      // Two frames: the start state is painted before the move begins.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.remove('is-waiting');
          el.classList.add('is-lit');
        });
      });
    });
  }, { threshold: 0.25 });

  function scan(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-chora-reveal]'), function (el) {
      if (el.__choraReveal) return;
      el.__choraReveal = true;
      var r = el.getBoundingClientRect();
      // Already filling the top half of the screen, or scrolled past: leave it as it is. A section
      // lower down plays as soon as a quarter of it shows, which can be at once.
      if (r.top < (window.innerHeight || 0) * 0.5) return;
      el.classList.add('is-waiting');
      io.observe(el);
    });
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
